import React from "react";
import { Box, Typography } from "@mui/material";
import { HOL, holFadeUp } from "../../../UserSide/pages/holTheme";

export const holHostPanelSx = {
  p: { xs: 2, sm: 2.5 },
  bgcolor: HOL.panel,
  backdropFilter: "blur(18px)",
  border: `1px solid ${HOL.panelBorder}`,
  borderRadius: "20px",
  boxShadow: "0 10px 32px rgba(0,0,0,0.28)",
};

export const holStageSx = {
  ...holHostPanelSx,
  position: "relative",
  overflow: "hidden",
  background:
    "radial-gradient(ellipse 60% 50% at 15% 0%, rgba(168,224,99,0.12) 0%, transparent 60%)," +
    "radial-gradient(ellipse 50% 45% at 90% 10%, rgba(255,107,61,0.1) 0%, transparent 55%)," +
    HOL.panel,
};

export const holGradientText = {
  background: `linear-gradient(90deg, ${HOL.higher} 0%, ${HOL.gold} 50%, ${HOL.lower} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

export const holDangerBtnSx = {
  textTransform: "none",
  fontFamily: HOL.fontDisplay,
  fontWeight: 800,
  letterSpacing: "0.04em",
  borderRadius: "12px",
  px: 2.5,
  color: "#fff",
  background: `linear-gradient(135deg, #ff5a5a 0%, ${HOL.lowerDeep} 100%)`,
  boxShadow: "0 8px 24px rgba(255,90,90,0.25)",
  "&:hover": { background: "linear-gradient(135deg, #ff7070 0%, #d64422 100%)" },
  "&.Mui-disabled": { background: "rgba(255,90,90,0.2)", color: "rgba(255,255,255,0.4)" },
};

export const holStartSessionBtnSx = {
  py: { xs: 1.25, sm: 1.6 },
  px: { xs: 3, sm: 5 },
  fontFamily: HOL.fontDisplay,
  fontWeight: 900,
  fontSize: { xs: "1rem", sm: "1.15rem" },
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  borderRadius: "16px",
  color: "#0a1206",
  background: `linear-gradient(160deg, ${HOL.higher} 0%, #7bc94a 55%, ${HOL.higherDeep} 100%)`,
  boxShadow: "0 12px 36px rgba(168,224,99,0.35)",
  "&:hover": {
    background: `linear-gradient(160deg, #b8f070 0%, ${HOL.higher} 50%, #6bb83a 100%)`,
    boxShadow: "0 16px 44px rgba(168,224,99,0.45)",
  },
  "&.Mui-disabled": { background: "rgba(168,224,99,0.22)", color: "rgba(255,255,255,0.4)" },
};

export const Eyebrow = ({ children, color = HOL.gold, sx }) => (
  <Typography
    sx={{
      color,
      fontFamily: HOL.fontDisplay,
      fontWeight: 800,
      letterSpacing: "0.2em",
      fontSize: { xs: "0.68rem", sm: "0.75rem" },
      textTransform: "uppercase",
      ...sx,
    }}
  >
    {children}
  </Typography>
);

/** Static playing card image (`card` = { suit, fileValue } or null for the back). */
export const CardImage = ({ suit, fileValue, width = 96, tilt = 0, sx }) => (
  <Box
    component="img"
    src={suit ? `/cards/${suit}_${fileValue}.png` : "/cards/back.png"}
    alt={suit ? `${fileValue} of ${suit}` : "Card back"}
    sx={{
      width,
      height: "auto",
      aspectRatio: "5 / 7",
      objectFit: "contain",
      borderRadius: "10px",
      transform: `rotate(${tilt}deg)`,
      filter: "drop-shadow(0 14px 28px rgba(0,0,0,0.55))",
      ...sx,
    }}
  />
);

export const StepShell = ({ children, maxWidth = 980 }) => (
  <Box sx={{ maxWidth, mx: "auto", animation: `${holFadeUp} 0.45s ease both` }}>{children}</Box>
);
